import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth-service';
import { DynamicModalService } from '../../../services/dialog-service';

@Component({
  selector: 'app-not-found',
  imports: [],
  templateUrl: './not-found.html',
  styleUrl: './not-found.scss',
})
export class NotFound {
  private readonly location = inject(Location);
  private readonly auth = inject(AuthService);
  private readonly modalService = inject(DynamicModalService);
  private readonly router = inject(Router);

  goBack() {
    this.location.back();
  }

  goHome() {
    if (this.auth.alreadyLoggedIn()) {
      this.modalService
        .open({
          iconType: 'mat',
          icon: 'info',
          title: 'Logout',
          description: 'This action will log you out of the system',
          acceptLabel: 'Yes, Logout',
          declineLabel: 'Cancel',
          theme: 'confirmation',
        })
        .then((result) => {
          if (result) {
            this.auth.logout();
          }
        });
    } else {
      this.router.navigate(['/']);
    }
  }
}
